import React from 'react'
import { Container, Row, Col } from "reactstrap";

import "../Footer/Footer.css";


const Footer = () => {
  return (
    <footer className="header">
      <div className="header__middle">
        < Container>
          <Row>
            <Col className="col">
              <div> 
                <p className="derechos">© Copyright 2023 - All Rights Reserved</p>
              </div>
            </Col>
            
          </Row>
        </Container>
        
      </div>
    </footer>
  )
}

export default Footer